<template>
    <v-container grid-list-xs fluid>
        <v-tabs centered v-if="$store.state.newTransact.all">
            <v-tab v-if="$store.state.newTransact.all">Revenue</v-tab>
            <v-tab v-if="$store.state.newTransact.all">Payroll</v-tab>
            <v-tab-item class="mx-5">
                <v-col cols="12">
                    <v-data-table :headers="headersReady" :items="revenue" dense :search="search" class="elevation-1"
                        v-if="$store.state.newTransact.all">
                        <template v-slot:top>
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field v-model="search" label="Search" class="mb-1" dense
                                        style="margin-top: 0px;padding: 10px;" hide-details></v-text-field>
                                </v-col>
                                <v-col cols="8">
                                    <v-btn color="primary" small class="my-auto mr-2"
                                        v-if="$store.state.roles == 'Administrator' || $store.state.roles == 'Admin – Supervisor'"
                                        @click="transact('transRevenue')">Transact
                                        Rev</v-btn>
                                    <v-btn color="primary" small class="my-auto ml-2"
                                        @click="getOrdertoTransactNotPost">Not
                                        Post </v-btn>
                                    <v-btn color="success" small class="my-auto ml-2" @click="getNoRateLoads">No
                                        Rates</v-btn>
                                    <!-- <v-btn color="primary" small class="my-auto ml-2" @click="getOrdertoTransactNotPost">Not
                                    Post Pay</v-btn> -->
                                    <v-btn icon left class="my-auto mr-2 float-right"
                                        @click="transacted"><v-icon>mdi-arrow-right</v-icon></v-btn>
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-col>
            </v-tab-item>

            <v-tab-item class="mx-5">
                <v-col cols="12">

                    <v-data-table :headers="headersReady" :items="payroll" dense :search="search" class="elevation-1"
                        v-if="$store.state.newTransact.all">
                        <template v-slot:top>
                            <v-row>
                                <v-col cols="4">
                                    <v-text-field v-model="search" label="Search" class="mb-1" dense
                                        style="margin-top: 0px;padding: 10px;" hide-details></v-text-field>
                                </v-col>
                                <v-col cols="8">
                                    <v-btn color="primary" small class="my-auto ml-2"
                                        v-if="$store.state.roles == 'Administrator' || $store.state.roles == 'Admin – Supervisor'"
                                        @click="transact('transPayroll')">Transact
                                        Pay</v-btn>
                                    <v-btn color="primary" small class="my-auto ml-2"
                                        @click="getOrdertoTransactNotPost">Not
                                        Post </v-btn>
                                    <v-btn color="success" small class="my-auto ml-2" @click="getNoRateLoads">No
                                        Rates</v-btn>
                                    <!-- <v-btn color="primary" small class="my-auto ml-2" @click="getOrdertoTransactNotPost">Not
                                    Post Pay</v-btn> -->
                                    <v-btn icon left class="my-auto mr-2 float-right"
                                        @click="transacted"><v-icon>mdi-arrow-right</v-icon></v-btn>
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-table>
                </v-col>
            </v-tab-item>
        </v-tabs>
        <transactions v-if="!$store.state.newTransact.all" :parms="parms" :Shifts="Shifts"></transactions>
        <notpost v-if="$store.state.newTransact.NotPost" :orders="orders" :Shifts="Shifts"></notpost>
        <NoRateLoad v-if="$store.state.newTransact.NoRate" :orders="NoRate"></NoRateLoad>
        <loads v-if="$store.state.newTransact.loads" :searchShift="shiftDetail"></loads>
    </v-container>
</template>
<script>
import transactions from './AllTransactions.vue';
import notpost from './../../Modals/Administration/Transacting/Revenue/NotPost.vue';
import NoRateLoad from './../../Modals/Administration/Transacting/NoRateLoad.vue';
import loads from './../../Modals/Administration/Transacting/OrdLoadModal.vue';
import axios from "axios";
export default {
    props: ['revenue','payroll', 'parms'],
    components: {
        notpost,
        transactions,
        NoRateLoad,
        loads
    },
    data: function () {
        return {
            Shifts: [],
            orders: [],
            search: '',
            exeptions: [],
            headersReady: [
                { text: 'Date', value: 'Date' },
                { text: 'ShiftDetail', value: 'ShiftDetail' },
                { text: 'Driver', value: 'Driver' },
                { text: 'Truck', value: 'Truck' },
                { text: 'Trailer', value: 'Trailer' },
                { text: 'Customer', value: 'Customer' },
                { text: 'OrderID', value: 'OrderID' },
            ],
            shiftDetail: 0,
        }
    },
    methods: {
        fiterShift: function () {
            const shifts = this.data.map(x => {
                return x.ShiftDetail;
            });
            this.Shifts = this.deleteDuplicate(shifts);
            console.log(this.Shifts);
        },
        deleteDuplicate: function (arr) {
            const resultado = [];
            for (const elemento of arr) {
                if (!resultado.includes(elemento)) {
                    resultado.push(elemento);
                }
            }
            return resultado;
        },
        transactByShift: async function () {
            var str = this.$store;
            let idx = 1;
            const shifts = await this.data.map(x => {
                return x.ShiftDetail;
            });
            this.Shifts = await this.deleteDuplicate(shifts);
            console.log(this.Shifts);
            const total = this.Shifts.length;
            for (const shift of this.Shifts) {
                console.log(shift);
                str.state.isLoading = true;
                await axios
                    .post('new-transaction/transRevenue/' + shift, '', {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(response => {
                        str.dispatch('setSnackbar', {
                            color: 'success',
                            text: 'Shift Transacted ' + (idx) + ' / ' + total,
                        });
                        idx++;
                        console.log(response.data)
                        this.$store.state.isLoading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                        str.state.isLoading = false;
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
            };
            this.$store.state.newTransact.revenue = false;
        },
        getNoRateLoads: function () {
            var str = this.$store;
            // str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
            };
            axios
                .post('new-transaction/no-rate/load', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.NoRate = response.data;
                    console.log(this.NoRate.length);
                    if (this.NoRate.length > 0) {
                        str.state.newTransact.NoRate = true;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                });
        },
        transact: async function (url) {
            var str = this.$store;
            
            var t = this;
            console.log(this.Shifts);
            let shifts;
            if (url == 'transRevenue') {
                shifts = await this.revenue.map(x => {
                    return x.ShiftDetail;
                });
                this.getNoRateLoads();
            }else{
                shifts = await this.payroll.map(x => {
                    return x.ShiftDetail;
                });
            }
            
            this.Shifts = await this.deleteDuplicate(shifts);
            var parms = {
                Shifts: this.Shifts
            }
            str.state.isLoading = true;
            await axios
                .post('new-transaction/' + url, parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data)
                    str.state.isLoading = false;
                    this.$store.state.newTransact.all = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        t.openModalTransact(error.response.data);
                        this.openModalTransact(error.response.data);
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        openModalTransact: function (shift) {
            this.shiftDetail = shift;
            var str = this.$store;
            str.dispatch('setSnackbar', {
                color: 'error',
                text: 'Correct LoadNum and repeat the Transact Payroll process.'
            });
            str.state.newTransact.loads = true;
        },
        transacted: async function () {

            // const shifts = await this.pa.map(x => {
            //     return x.ShiftDetail;
            // });
            // this.Shifts = await this.deleteDuplicate(shifts);
            this.$store.state.newTransact.all = !this.$store.state.newTransact.all;
        },
        getOrdertoTransactNotPost: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                Daily: false,
            };
            axios
                .post('new-transaction/not-post', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.orders = response.data;
                    this.$store.state.newTransact.NotPost = true;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
        getExceptions: function () {
            var str = this.$store;
            str.state.isLoading = true;
            var parms = {
                StartDate: this.$store.state.getMsk('StartDate'),
                EndDate: this.$store.state.getMsk('EndDate'),
                // Customer: this.customer.id,
            };
            axios
                .post('new-transaction/exceptions', parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    this.exeptions = response.data;
                    this.$store.state.newTransact.exception = true;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    str.state.isLoading = false;
                });
        },
    }
}
</script>